/**
 * @deprecated use `STYLES.colors` from `@vita-learning/styles` instead
 */
export enum Color {
	PRIMARY = "#00A6FF",
	SECONDARY = "#0091FF",
	CANCEL = "#78828A",
	COMPLEMENTARY = "#FFD900",
	CANCEL_POP = "#6C757D",
	DANGER = "#D9534F", // or #FF0000
	DANGER_TEXT = "#721C24",
	BACKGROUND = "#F6F8FE",
	DARK_BACKGROUND = "#212121",
	OFF_WHITE = "#F9F9F9",
	CONTAINER = "#FFF",
	DARK_CONTAINER = "#2C2C2C",
	INPUT = "#FFF",
	DARK_INPUT = "#2C2C2C",
	WARNING = "#F0AD4E",
	WARNING_TEXT = "#856404",
	SUCCESS = "#5CB85C",
	SUCCESS_TEXT = "#155724",
	INFO = "#5BC0DE",
	INFO_TEXT = "#0C5460",
	FADED = "#F7F7F7",
	FORM = "#F9F9F9",
	BORDER_LINE = "#CCC",
	BORDER_LINE_LIGHT = "#EFEFEF",
	BORDER_LINE_DARK = "#B3B3B3",
	DARK_BORDER_LINE = "#",
	DARK_BORDER_LINE_LIGHT = "#",
	DARK_BORDER_LINE_DARK = "#",
	CONSTRUCTION = "#FAD201",
	ICON_BUTTON = "#91A9C7",
	ICON_BUTTON_INTERACTION = "#809CBE",

	/**
	 * @deprecated
	 */
	LIGHT_BORDER_LINE = "#F1F1F1",
	DARK_SHY_INTERACTION = "#91A9C7",
	SHY_INTERACTION_DARK_POP = "#",
	TOOLTIP = "#2B2B2B",
	DARK_TOOLTIP = "#EAEAEA",
	TEXT = "#444",
	LIGHT_TEXT = "#666",
	DARK_TEXT = "#FFF",
	DARK_SHY_TEXT = "#",
	SHY_TEXT = "#CFCFCF",
	COLUMN_BACKGROUND = "#FAFBFE",
	GOOGLE_BLUE = "#4285F4",
	GOOGLE_BLUE_ACTIVE = "#1669F2",
	FACEBOOK = "#4267B2",
}

/**
 * @deprecated use `STYLES.fonts.sizes` from `@vita-learning/styles` instead
 */
export enum FontSize {
	XS = "12px",
	SM = "16px",
	MD = "20px",
	LG = "24px",
	XL = "30px",
	XXL = "36px",
}

/**
 * @deprecated use `STYLES.fonts.weights` from `@vita-learning/styles` instead
 */
export enum FontWeight {
	NORMAL = 400,
	BOLD = 500,
	THICK = 600,
}

/**
 * @deprecated use `STYLES.breakpoints` from `@vita-learning/styles` instead
 */
export enum Breakpoint {
	MOBILE_LANDSCAPE = "min-width: 576px",
	TABLET_PORTRAIT = "min-width: 768px",
	TABLET_LANDSCAPE = "min-width: 992px",
	LAPTOP_SMALL = "min-width: 1200px",
	LAPTOP_LARGE = "min-width: 1440px",
	DESKTOP = "min-width: 2100px",
}

/**
 * @deprecated
 */
export enum BreakpointHeight {
	TALL = "min-height: 1000px",
}

/**
 * @deprecated
 */
export enum DeviceOrientation {
	PORTRAIT = "orientation: portrait",
	LANDSCAPE = "orientation: landscape",
}

/**
 * @deprecated use `STYLES.spacings` from `@vita-learning/styles` instead
 */
export enum Spacing {
	XXS = "2px",
	XS = "5px",
	SM = "10px",
	MD = "15px",
	LG = "20px",
	XL = "25px",
	XXL = "30px",
}

/**
 * @deprecated use `STYLES.shadows` from `@vita-learning/styles` instead
 */
export enum Shadow {
	LIGHT = "rgba(0, 0, 0, 8%)",
	NORMAL = "rgba(0, 0, 0, 16%)",
	HEAVY = "rgba(0, 0, 0, 32%)",
}

// Extras
// $nav-background= #313A46,
